module.exports = __webpack_public_path__ + "media/bg-loop.76aa960e.mp4";